import { html } from "lit-html";
import { OrangeBookJsEnv } from "../../../models/orange_book/orange_book_js_env";
import { OrangeBookAction } from "../../../actions/orange_book/orange_book_action";
import { encodeString } from "../../../util/browser_util";

const BASE_URL = `${window.location.protocol}//${window.location.host}/`

export const OrangeBookArea = (model: OrangeBookJsEnv) => html`
<div class="o-menuBar_orangebook">
  <p class="o-menuBar_heading">オレンジブックの<br/>発注コードで探す</p>
  <div class="a-textinput js-input">
    <span class="a-textinput_inputwrap">
      <input type="text" class="a-textinput_input" placeholder="7桁の数字を入力" autocomplete="off"
        @keyup="${(event: Event) => {
          OrangeBookAction.getOrangeBookCode(getValueFromEvent(event));
      }}"/>
    </span>
  </div>
  <button class="m-btn -auto-16 -small" type="button"
    .disabled="${model.inputWord === ''}"
      @click="${() => window.location.href = BASE_URL + CreateUrl(model)}">
    <span class="m-btn_inner">
      <span class="m-btn_text">検索</span>
    </span>
  </button>
</div>
`;

const CreateUrl = (model: OrangeBookJsEnv) => {
  return `ksearch/?` +
  `refineKbn=` + model.refineKbn + `&` +
  `callBackKbn=` + model.callBackKbn + `&` +
  `categoryLl=` + model.llCategoryCode + `&` +
  `categoryL=` + model.lCategoryCode + `&` +
  `refineCD1=${encodeString(model.inputWord)}`;
}

const getValueFromEvent = (event: Event): string => {
  const { target } = event;

  if (!(target instanceof HTMLInputElement)) {
    throw new Error('cannot get value from event.');
  }

  return target.value;
}
